
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skiomrade",
      function () {
        return require("private-next-pages/[region]/skiomrade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skiomrade"])
      });
    }
  